import { AxiosError } from 'axios';
import { useState } from 'react';

import { CurrentConfigDataInterface } from '../../../models/dashboard/dashboard/currentConfigData';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import { currentConfigDataActions } from '../../../redux/slices/currentConfigDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useCurrentConfigData = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onCurrentConfigError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ??
        'Something went wrong while retrieving driver overview data',
    );
  };

  const onCurrentConfigSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<CurrentConfigDataInterface>) => {
    dispatch(currentConfigDataActions.setCurrentConfigData(data));
  };

  const getCurrentConfigData = async () => {
    const url: HttpConfig = {
      url: `ba/v1/configs/current`,
      method: 'get',
    };

    return request(
      url,
      onCurrentConfigSuccess,
      setLoading,
      onCurrentConfigError,
    );
  };

  return { getCurrentConfigData, loading };
};

export default useCurrentConfigData;
